
	
  var sku_values_l = ''; //Valor de todas las combinaciones colocadas en el ojo izquierdo
  var sku_values_r = ''; //Valor de todas las combinaciones colocadas en el ojo derecho
  var var_l_sph = ''; //Este es el valor del SPH en el ojo izquierdo
  var var_r_sph = ''; //Este es el valor del SPH en el ojo derecho
	
$('#left-poder-sph').click(function() {
    var_l_sph = $('#4608401670249_option_4').val();
	console.log(var_l_sph); 
	unify_values_l();
	fetch_sku_l();
});


$('#right-poder-sph').click(function() {
    var_r_sph = $('#4608401670249_option_5').val();
	console.log(var_r_sph); 
	unify_values_r();
	fetch_sku_r();
});


function unify_values_l(){
	sku_values_l = var_l_sph ;
	console.log(sku_values_l);
}

function unify_values_r(){
	sku_values_r = var_r_sph;
	console.log(sku_values_r);
}


function fetch_sku_l(){
 	switch (sku_values_l) {

case '-10.00' : $('.contact-lens-configurator').addClass('left-deny-atc'); $('.left-deny-error').remove(); $('<span class="left-deny-error">Actualmente esta graduación está fuera de disponibilidad por parte de nuestro proveedor. <a href="https://api.whatsapp.com/send?phone=525551172771" target="_blank">Contáctate con uno de nuestros especialistas</a> y te ofreceremos una alternativa</span>').insertBefore('.left-section .box-qty'); break;

 	    default:
        	$('#left-sku input').val('SKU Desconocido'); $('.contact-lens-configurator').removeClass('left-deny-atc');$('.left-deny-error').remove();
    }
}//fetch_sku()



function fetch_sku_r(){
 	switch (sku_values_r) {

case '-10.00' : $('.contact-lens-configurator').addClass('right-deny-atc'); $('.right-deny-error').remove(); $('<span class="right-deny-error">Actualmente esta graduación está fuera de disponibilidad por parte de nuestro proveedor. <a href="https://api.whatsapp.com/send?phone=525551172771" target="_blank">Contáctate con uno de nuestros especialistas</a> y te ofreceremos una alternativa</span>').insertBefore('.right-section .box-qty'); break;

		default:
        	$('#right-sku input').val('SKU Desconocido'); $('.contact-lens-configurator').removeClass('right-deny-atc');$('.right-deny-error').remove();
    }
}//fetch_sku()
